module.exports = __webpack_public_path__ + "static/media/webvision3.41fc1c20.png";